/**
 * Chat bubble used in the feature bento "Talk to Lincoln" preview.
 * - side='user'   → right-aligned yellow bubble
 * - side='lincoln' → left-aligned dark bubble with the m logo
 * Pass `typing` to show animated dots.
 */
export default function ChatBubble({ side, text, typing }) {
  const isUser = side === 'user';
  return (
    <div
      className="flex items-center gap-2"
      style={{
        alignSelf: isUser ? 'flex-end' : 'flex-start',
        maxWidth: '85%',
        background: isUser ? 'var(--yellow)' : 'rgba(255,255,255,0.12)',
        color: isUser ? 'var(--navy)' : '#fff',
        padding: '10px 14px',
        borderRadius: 14,
        fontSize: 14,
        fontWeight: 500,
        borderBottomLeftRadius: isUser ? 14 : 4,
        borderBottomRightRadius: isUser ? 4 : 14,
      }}
    >
      {!isUser && (
        <span
          className="inline-flex items-center justify-center rounded-full font-serif font-bold flex-shrink-0"
          style={{ width: 18, height: 18, background: 'var(--yellow)', fontSize: 11, color: 'var(--navy)' }}
        >m</span>
      )}
      <span>{text}</span>
      {typing && (
        <span className="inline-flex gap-0.5">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="block rounded-full"
              style={{ width: 4, height: 4, background: 'rgba(255,255,255,0.6)', animation: `lc-wave 1.4s ${i * 0.2}s infinite` }}
            />
          ))}
        </span>
      )}
    </div>
  );
}
